import { LocalStyles } from "@paperbits/common/styles";

export class ChangePasswordModel {
    public requireHipCaptcha: boolean;

    /**
     * Widget local styles.
     */
    public styles: LocalStyles = {};
}
